export default __webpack_public_path__ + "static/social media 4-ee96657756dd2d0d1485611dd4a16da9.webp";